<template>
    <v-app>
        <!--navbar-->
        <navbar-top
            @toggleMenu="showMainMenu=!showMainMenu"
            @toggleUserPanel="showUserPanel=!showUserPanel"
            :clipped-left="clipped"
            :has-menu="hasMenu"
            >
            <slot slot=title name="title"><v-avatar size="45px" tile><img src="/logo.png" alt="" title="" /></v-avatar> {{trans('layout.title')}}</slot>
            <slot name="header"></slot>
        </navbar-top>
        <menu-main
                :clipped="clipped"
                v-model="showMainMenu"
                v-if="hasMenu"
                />
        <user-panel
            v-model="showUserPanel"
            />

        <!-- Content -->
        <v-main>
            <slot name="content">
                <v-container>
                        <slot>Nothing here right now!</slot>
                </v-container>
            </slot>
        </v-main>
    </v-app>
</template>
<style lang="scss">
    .v-toolbar{
        .logo-main{
            height:45px;
        }
    }
</style>
<script>
import NavbarTop from './partials/NavbarTop'
import MenuMain from './partials/MenuMain'
import AppFooter from './partials/Footer'
import UserPanel from './partials/UserPanel'
import {mapGetters} from "vuex";

export default {
        name:'app-layout',
        props: {},
        data() {
            return {
                clipped         : true,
                showMainMenu    : null,
                showUserPanel   : false,
            }
        },
        mounted() {
        },
        computed: {
            ...mapGetters({
                menu:'mainMenu',
            }),
            hasMenu(){return this.menu && this.menu.length>0},
        },
        methods: {},

        components: {
            NavbarTop,
            MenuMain,
            AppFooter,
            UserPanel,
        },
        filters: {}
    }
</script>
